import {useState} from 'react';
import {createTicket, TicketData} from '../../services/SalesRep/createTicket';
import {toast, Bounce} from 'react-toastify';

export const useNewTicketForm = (clients: any[]) => {
    const [selectedClient, setSelectedClient] = useState('');
    const [filteredPlants, setFilteredPlants] = useState([]);
    const [selectedPlant, setSelectedPlant] = useState('');
    const [selectedService, setSelectedService] = useState('');
    const [description, setDescription] = useState('');
    const [additionalComment, setAdditionalComment] = useState('');
    const [loading, setLoading] = useState(false); // Add loading state
    const [selectedEquipments, setSelectedEquipments] = useState<any>([]);
    const [filteredEquipments, setFilteredEquipments] = useState<any>([]);

    const handleAddEquipment = (newEquipmentId: any) => {
        const newEquipment = filteredEquipments.find(
            (equipment: any) => equipment.id === parseInt(newEquipmentId)
        );

        if (!newEquipment) {
            toast.error(`Error al agregar equipo`, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return;
        }

        setSelectedEquipments((prevEquipments: any) => {
            if (prevEquipments.some((equipment: any) => equipment.id === newEquipment.id)) {
                return prevEquipments;
            }
            return [...prevEquipments, newEquipment];
        });
    };


    const handleRemoveEquipment = (equipmentId: number) => {
        setSelectedEquipments((prevEquipments: any) =>
            prevEquipments.filter((equipment: any) => equipment.id !== equipmentId)
        );
    };

    const resetForm = () => {
        setSelectedClient('');
        setFilteredPlants([]);
        setSelectedPlant('');
        setSelectedService('');
        setDescription('');
        setAdditionalComment('');
        setSelectedEquipments([]);
    };

    const handleClientChange = (clientId: string) => {
        setSelectedClient(clientId);
        setSelectedPlant('');
        setSelectedEquipments([])

        const selectedClient = clients.find((client) => client.id === parseInt(clientId));
        if (selectedClient) {
            setFilteredPlants(selectedClient.plants);
        } else {
            setFilteredPlants([]);
        }
    };

    const handlePlantChange = (plantId: string) => {
        setSelectedPlant(plantId);
        setSelectedEquipments([]);

        const selectedPlant = clients
            .flatMap(client => client.plants)
            .find((plant: any) => plant.id === parseInt(plantId));

        setFilteredEquipments(selectedPlant ? selectedPlant.equipments : []);
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setLoading(true);

        const ticketData: TicketData = {
            service: selectedService,
            description,
            additionalComment,
            equipments: selectedEquipments.map((equipment: { id: any; }) => equipment.id)
        };

        try {
            await createTicket(ticketData, Number(selectedPlant));
            toast.success('¡Ticket creado correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            resetForm();
        } catch (err: any) {
            toast.error(`Error al crear nuevo ticket`, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        } finally {
            setLoading(false);
        }
    };

    return {
        formState: {
            selectedClient,
            filteredPlants,
            selectedPlant,
            selectedService,
            description,
            additionalComment,
            selectedEquipments,
            filteredEquipments
        },
        actions: {
            setSelectedClient,
            handleClientChange,
            setSelectedPlant,
            setSelectedService,
            setDescription,
            setAdditionalComment,
            resetForm,
            handleSubmit,
            handleAddEquipment,
            handleRemoveEquipment,
            handlePlantChange,
            loading, // Add loading to the returned actions
        },
    };
};
